import { combineReducers } from "redux";
import api from "../../api";
import app from "./slices/app";
import auth from "./slices/auth";
import user from "./slices/user";

const appReducer = combineReducers({
  [auth.name]: auth.reducer,
  [user.name]: user.reducer,
  [app.name]: app.reducer,
  [api.reducerPath]: api.reducer,
});

const rootReducer: typeof appReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
